var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvayaFooterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 23,
    viewBox: "0 0 81 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8812 -0.000976562L61.8293 16.4764H65.0758L66.2486 13.9754H73.6018L72.7192 11.7971H67.2717L71.0014 3.75378L76.931 16.4764H80.1775L72.1269 -0.000976562H69.8812Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42449 -0.000488281L0.371338 16.4769H3.61913L4.79322 13.9759H12.1424L11.2625 11.7975H5.81628L9.54605 3.75427L15.4743 16.4769H18.7194L10.6702 -0.000488281H8.42449Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0377 -0.000976562L30.9859 16.4764H34.2324L35.4052 13.9754H42.7583L41.8758 11.7971H36.4282L40.1593 3.75378L46.0888 16.4764H49.334L41.2835 -0.000976562H39.0377Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7886 -0.000976562L24.8604 12.963L18.9282 -0.000976562H15.6896L23.7349 16.4764H23.8689H25.8467H25.9846L34.0325 -0.000976562H30.7886Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6994 -0.000976562L55.5242 13.2056L49.8377 -0.000976562H46.5938L53.9155 16.4764L50.7241 22.6626H53.8288L64.9393 -0.000976562H61.6994Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvayaFooterLogo);
export default __webpack_public_path__ + "static/media/avaya-footer-logo.a0ec742f01e83b95c72315429aed5824.svg";
export { ForwardRef as ReactComponent };